export default __webpack_public_path__ + "static/media/Poppins-Regular.1c701c9a.ttf";